import getAccessToken from './methods/getAccessToken'
import getAuthData from './methods/getAuthData'
import isAuthenticated from './methods//isAuthenticated'
import signin from './methods/signin'
import signout from './methods/signout'
import type {
  AuthConfig,
  AuthClient,
  GetAuthDataOptions,
  IdTokenProfile,
  IsAuthenticatedOptions,
  Provider,
  SignInOptions,
  SignOutOptions,
} from './types/types'
import type { Tokens } from './types/tokenTypes'
import setTokens from './methods/setTokens'
import getUserData from './methods/getUserData'
import setCurrentContact from './methods/setCurrentContact'
import getContacts from './methods/getContacts'
import getTokensForContact from './methods/getTokensForContact'
import getZendeskToken from './methods/getZendeskToken'
import getIdTokenProfile from './methods/getIdTokenProfile'
import { authApiHandler } from './services/authApi'

export { default as cookieHandler, names as cookieNames } from './handlers/cookieHandler'
export {
  authCookieOptions,
  httpOnlyCookieNames,
  omitServerOnlyCookies,
  withAuthCookieOptions,
} from './handlers/authCookies'
export type { AuthCookie, AuthCookieOptions, IsHttpOnlyEnabled } from './handlers/authCookies'
export { isSecureHost, refreshServerTokens } from './methods/refreshServerTokens'
export { getToken as decodeToken } from './handlers/tokenHandler'
export type {
  RefreshServerTokensOptions,
  ServerTokenRefreshOutcome,
  ServerTokenRefreshResult,
} from './methods/refreshServerTokens'
export type {
  AccessTokenContactData,
  AccessTokenData,
  AccessTokenIdentityProviderData,
  IdTokenData,
  TokenData,
  Tokens,
  ValidTokens,
} from './types/tokenTypes'
export type {
  AuthConfig,
  AuthData,
  Contact,
  AuthClient,
  GetAuthDataOptions,
  GetTokensForContactResult,
  IdTokenProfile,
  IdentityProvider,
  IdentityProviderName,
  IsAuthenticatedOptions,
  IssuerProvider,
  Profile,
  Provider,
  SignInOptions,
  SignOutOptions,
  SiteType,
  SourcingCompany,
  UserData,
} from './types/types'

export const dustinAuth = (config: AuthConfig, cookieHeader?: string): AuthClient => {
  return {
    isAuthenticated: (options?: IsAuthenticatedOptions) =>
      isAuthenticated(config, cookieHeader)(options),
    signIn: (options?: SignInOptions) => signin(config, cookieHeader)(options),
    signOut: (options?: SignOutOptions) => signout(config)(options),
    getAccessToken: () => getAccessToken(config, cookieHeader)(),
    refreshSession: () =>
      typeof window === 'undefined'
        ? Promise.resolve(false)
        : authApiHandler(config)
            .refreshSessionViaServer()
            .then(result => result.authenticated),
    getZendeskToken: () => getZendeskToken(config, cookieHeader)(),
    setTokens: (tokens: Tokens, provider: Provider) => setTokens(cookieHeader)(tokens, provider),
    getAuthData: (code: string, options?: GetAuthDataOptions, contactId?: number) =>
      getAuthData(config, cookieHeader)(code, options, contactId),
    getUserData: (browserProfile?: IdTokenProfile | null) =>
      getUserData(config, cookieHeader)(browserProfile),
    getIdTokenProfile: () => getIdTokenProfile(config, cookieHeader)(),
    setCurrentContact: (contactId: number) => setCurrentContact(config)(contactId),
    getContacts: () => getContacts(config, cookieHeader)(),
    getTokensForContact: (contactId: number) =>
      getTokensForContact(config, cookieHeader)(contactId),
  }
}
